import Vue from 'vue'
import Main from './app/domains/Main'
import store from './app/plugins/store'
import router from './app/plugins/router'
import { sync } from 'vuex-router-sync'

import Acl from 'vue-acl'
Vue.use(Acl, { router: router, init: 'public' })

import element from './app/plugins/element'
Vue.use(element)


import VCalendar from 'v-calendar';
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

import ViaCep from 'vue-viacep'
Vue.use(ViaCep);
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.config.productionTip = false


import http from './app/plugins/http'
Vue.use(http)


// Effortlessly keep vue-router and vuex store in sync.
sync(store, router) // https://github.com/vuejs/vuex-router-sync/tree/next

require('./assets/scss/app.scss');

import moment from 'moment'
moment.locale('pt-br')
Vue.prototype.$moment = moment
Vue.prototype.moment = moment

import money from 'v-money'

// register directive v-money and component <money>
Vue.use(money, {precision: 4})

import ElTableEdit from "el-table-edit";
import {isNull} from "lodash";
Vue.use(ElTableEdit);

let formatter = new Intl.NumberFormat('pt-BR', {
  style: 'decimal',
  currency: 'BRL',
  minimumFractionDigits: 2
})

Vue.filter('toR$', function (price) {
  if (price === undefined) {
    return formatter.format(0)
  }
  return formatter.format(price)
  // return '' + (price === 0) ? '-' : formatter.format(price)
})
Vue.filter('formatCNPJ', function (document) {
  return '' + document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
})

Vue.filter('formatDocument', function (document) {
  if (!document) return '';

  document = document.replace(/\D/g, '');

  if (document.length === 11) {
    return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  } else if (document.length === 14) {
    return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  } else {
    return document;
  }
});

Vue.prototype.$appName = 'POS PORTAL'
Vue.prototype.$setTheme = (theme) => {
  
  if (!isNull(document.getElementById('rootCSS'))) {
    document.getElementById('rootCSS').remove()
  }
  let e = document.createElement('style');
  const css = document.createTextNode(
`
      :root {
        --primary-color: ${theme.colorPrimary};
        --secondary-color: ${theme.colorSecondary};
      }
    `
  )
  e.setAttribute('type', 'text/css');
  e.setAttribute('id', 'rootCSS');
  e.appendChild(css)
  // document.getElementsByTagName('head').appendChild(e);
  document.getElementsByTagName('head')[0].append(e)
}

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(Main),
  mounted() {
    document.title = 'Plataforma de Gestão';
  }
}).$mount('#app')
